module.exports = __webpack_public_path__ + "media/stylesheets/images/register_coupon_login-7c8aa353d1d537f873b00eb62a521de8.png";